package com.zq.my_official_website

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport

@OptIn(ExperimentalComposeUiApi::class)
fun main() {
    // 挂到专用的 #composeTarget 容器，避免接管整个 <body> 把 Tawk.to 等第三方脚本注入的节点清掉
    ComposeViewport(viewportContainerId = "composeTarget") {
        App()
    }
}